/**
 * @license @tabler/icons-vue v3.29.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createVueComponent from '../createVueComponent.mjs';

var IconCircleCheck = createVueComponent("outline", "circle-check", "IconCircleCheck", [["path", { "d": "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", "key": "svg-0" }], ["path", { "d": "M9 12l2 2l4 -4", "key": "svg-1" }]]);

export { IconCircleCheck as default };
//# sourceMappingURL=IconCircleCheck.mjs.map
